"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var vehicle_1 = require("../../../shared/model/vehicle");
var diagnosis_web_socket_service_1 = require("../../service/diagnosis-web-socket.service");
var Observable_1 = require("rxjs/Observable");
var diagnosis_general_result_1 = require("../../../shared/model/diagnosis-general-result");
var VehicleDisplayComponent = /** @class */ (function () {
    function VehicleDisplayComponent(_diagnosisNotification) {
        this._diagnosisNotification = _diagnosisNotification;
        this.running = true;
        this.loadingText = 'Indisponível';
        this.restartAutomatically = false;
        this.modalActions = new core_1.EventEmitter();
        this.vehicle = new vehicle_1.Vehicle();
        this.setUpDiagnosisFinished();
    }
    VehicleDisplayComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(VehicleDisplayComponent.prototype, "run", {
        get: function () {
            return this._run;
        },
        set: function (run) {
            this._run = run;
        },
        enumerable: true,
        configurable: true
    });
    VehicleDisplayComponent.prototype.restartDiagnosis = function () {
        this._diagnosisNotification.restart();
        this.running = true;
    };
    VehicleDisplayComponent.prototype.restartDiagnosisAutomatically = function () {
        this.restartAutomatically = !this.restartAutomatically;
        if (!this.running && this.restartAutomatically) {
            this.restartDiagnosis();
        }
    };
    VehicleDisplayComponent.prototype.resetDiagnosis = function (vehicle) {
        this.setDiagnosisVehicle(vehicle);
        this._diagnosisNotification.run(vehicle);
        this.running = true;
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    };
    VehicleDisplayComponent.prototype.setDiagnosisVehicle = function (vehicle) {
        this.vehicle = vehicle;
        this._diagnosisNotification.setVehicle(vehicle);
    };
    VehicleDisplayComponent.prototype.closeModal = function () {
        this.modalActions.emit({ action: 'modal', params: ['close'] });
    };
    VehicleDisplayComponent.prototype.setUpDiagnosisFinished = function () {
        var _this = this;
        this._diagnosisNotification.response$
            .debounce(function () {
            var time = 0;
            if (_this.restartAutomatically) {
                time = 60000;
            }
            return Observable_1.Observable.timer(time);
        })
            .filter(function (response) { return response instanceof Array || response instanceof diagnosis_general_result_1.DiagnosisGeneralResult; })
            .subscribe(function (response) {
            if (_this.restartAutomatically) {
                _this.running = true;
                _this.restartDiagnosis();
            }
            else {
                _this.running = false;
            }
        });
    };
    VehicleDisplayComponent.prototype.isInRunMode = function () {
        if (this._run === undefined) {
            return false;
        }
        return this._run;
    };
    VehicleDisplayComponent.prototype.restartIsEnabled = function () {
        if (this.enableRestart === undefined) {
            return true;
        }
        return this.enableRestart;
    };
    VehicleDisplayComponent.prototype.restartAutomaticallyIsEnabled = function () {
        if (this.enableRestartAutomatically === undefined) {
            return true;
        }
        return this.enableRestartAutomatically;
    };
    VehicleDisplayComponent.ctorParameters = function () { return [{ type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }]; };
    return VehicleDisplayComponent;
}());
exports.VehicleDisplayComponent = VehicleDisplayComponent;
//# sourceMappingURL=vehicle-display.component.js.map


// WEBPACK FOOTER //
// vehicle-display.component.js